import { useApiFetch } from '@/composables/useApiFetch'
import type { AddressPayload } from '~~/layers/base/stores/contact.store'

export type ProfileAddressRecord = {
    id: string
    label: string | null
    prefix: string | null
    suffix: string | null
    first_name: string | null
    middle_name: string | null
    last_name: string | null
    nickname: string | null
    raw_address_str: string | null
    street_address_1: string | null
    street_address_2: string | null
    city: string | null
    state: string | null
    zip_code: string | null
    country: string | null
    /** ISO country code dual-written on create/update (migration `0049_address_country_code`). */
    country_code: string | null
    is_default: boolean
    profile_id: string | null
    contact_id: string | null
    handwriting_stationery_id: string | null
    created_at: string
    last_modified_at: string
}

export const useAddressService = () => {
    /** List profile-owned addresses used for handwritten return-address selection. */
    const doFetchAddressList = async () => {
        return useApiFetch<{ addresses: ProfileAddressRecord[] }>('/api/addresses', {
            method: 'GET',
        })
    }

    /** Create one profile-owned return address. */
    const doCreateAddress = async (
        body: AddressPayload & { is_default?: boolean; handwriting_stationery_id?: string | null }
    ) => {
        return useApiFetch<{ address: ProfileAddressRecord }>('/api/addresses', {
            method: 'POST',
            body,
        })
    }

    /** Update one profile-owned return address by id. */
    const doPatchAddress = async (
        id: string,
        body: Partial<AddressPayload> & { is_default?: boolean }
    ) => {
        return useApiFetch<{ address: ProfileAddressRecord }>(`/api/addresses/${id}`, {
            method: 'PATCH',
            body,
        })
    }

    return {
        doFetchAddressList,
        doCreateAddress,
        doPatchAddress,
    }
}
